module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex_row_space_between_center"
  }, [_c('div', {
    staticClass: "flex_row_start_center"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.uploadClick(false)
      }
    }
  }, [_c('Upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doWhat == 'edit'),
      expression: "doWhat=='edit'"
    }],
    ref: "picUploader",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "show-upload-list": false,
      "action": "/aries-api/resource/upload",
      "data": _vm.uploadPicData,
      "multiple": "",
      "before-upload": _vm.handlePicBeforeUpload,
      "on-success": _vm.handlePicSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("\n            上传\n            "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1), _vm._v(" "), (_vm.previewList.length > 0) ? _c('div', {
    on: {
      "click": function($event) {
        return _vm.uploadClick(true)
      }
    }
  }, [_c('Upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doWhat == 'edit'),
      expression: "doWhat=='edit'"
    }],
    ref: "picChange",
    attrs: {
      "show-upload-list": false,
      "action": "/aries-api/resource/upload",
      "data": _vm.uploadPicData,
      "multiple": "",
      "before-upload": _vm.handlePicBeforeUpload,
      "on-success": _vm.chgPicSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("\n            替换\n            "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPIcUploading),
      expression: "isPIcUploading"
    }],
    staticStyle: {
      "width": "200px",
      "margin-left": "10px"
    }
  }, [_c('Progress', {
    attrs: {
      "percent": _vm.uploadPercent,
      "status": _vm.uploadStatus
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex_row_end_center"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAudioUploading),
      expression: "isAudioUploading"
    }],
    staticStyle: {
      "width": "200px"
    }
  }, [_c('Progress', {
    attrs: {
      "percent": _vm.audioUploadPercent,
      "status": _vm.audioUploadStatus
    }
  })], 1), _vm._v(" "), (_vm.previewList.length > 0) ? _c('div', [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doWhat == 'edit'),
      expression: "doWhat=='edit'"
    }],
    attrs: {
      "action": "/aries-api/resource/upload",
      "multiple": "",
      "accept": "audio/mp3",
      "before-upload": _vm.onBeforeMultyUploadAudio,
      "on-success": _vm.onSuccessMultyUploadAudio,
      "data": _vm.uploadAudioData,
      "show-file-list": false
    }
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top-start"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n              音频命名规则：\n              "), _c('br'), _vm._v("上传讲解：对应图片p1，音频命名为p1.mp3\n              "), _c('br'), _vm._v("上传原音：对应图片p1，音频命名为1.mp3\n            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-upload"
    }
  }, [_vm._v("批量导入音频")])], 1)], 1)], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "editor-container clearfix"
  }, [(_vm.previewList.length > 0) ? _c('div', {
    staticClass: "editor-row clearfix"
  }, [_c('div', {
    staticClass: "editor-preview"
  }, [_c('PreviewList', {
    attrs: {
      "axis": 'xy',
      "lockAxis": 'xy',
      "distance": 10,
      "helperClass": 'sort-preview'
    },
    on: {
      "sort-end": function($event) {
        return _vm.onPreviewSortEnd($event)
      }
    },
    model: {
      value: (_vm.previewList),
      callback: function($$v) {
        _vm.previewList = $$v
      },
      expression: "previewList"
    }
  }, _vm._l((_vm.previewList), function(item, index) {
    return _c('PreviewItem', {
      key: index,
      class: {
        curr: index === _vm.currIndex
      },
      style: (_vm.chgMode ? 'opacity:1' : ''),
      attrs: {
        "index": index,
        "item": item,
        "disabled": _vm.doWhat == 'view'
      }
    }, [_c('div', {
      staticClass: "flex-img",
      on: {
        "click": function($event) {
          return _vm.onSelectThumb(item, index)
        }
      }
    }, _vm._l((item.image), function(img, idx) {
      return _c('div', {
        key: idx,
        style: ({
          backgroundImage: ("url(" + img)
        })
      }, [_c('p', {
        staticClass: "pageNumShow"
      }, [_vm._v("P" + _vm._s(index + 1))])])
    }), 0), _vm._v(" "), _c('Icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.doWhat == 'edit'),
        expression: "doWhat=='edit'"
      }],
      staticClass: "pageHiddenShow",
      attrs: {
        "type": item.isHidden == 1 ? 'ios-eye-off' : 'ios-eye',
        "size": "24",
        "color": item.isHidden == 1 ? 'red' : 'green'
      },
      on: {
        "click": function($event) {
          return _vm.hiddenPage(index)
        }
      }
    }), _vm._v(" "), _c('Poptip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.doWhat == 'edit'),
        expression: "doWhat=='edit'"
      }],
      staticClass: "poptip-remove",
      attrs: {
        "confirm": "",
        "title": "您确定要删除此页么？",
        "transfer": true
      },
      on: {
        "on-ok": function($event) {
          return _vm.onRemovePage(index)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-close-circle",
        "size": "16",
        "color": "#ed4014"
      }
    })], 1)], 1)
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.chgMode) ? _c('div', {
    staticClass: "editor-row clearfix"
  }, [_c('div', {
    staticClass: "editor-preview"
  }, [_c('PreviewList', {
    attrs: {
      "axis": 'xy',
      "lockAxis": 'xy',
      "distance": 10,
      "helperClass": 'sort-preview'
    },
    on: {
      "sort-end": function($event) {
        return _vm.onChgSortEnd($event)
      }
    },
    model: {
      value: (_vm.chgPDFPage),
      callback: function($$v) {
        _vm.chgPDFPage = $$v
      },
      expression: "chgPDFPage"
    }
  }, _vm._l((_vm.chgPDFPage), function(item, index) {
    return _c('PreviewItem', {
      key: index,
      class: {
        curr: index === _vm.currChgIndex
      },
      staticStyle: {
        "opacity": "1"
      },
      attrs: {
        "index": index,
        "item": item
      }
    }, [_c('div', {
      staticClass: "flex-img",
      on: {
        "click": function($event) {
          return _vm.onSelectChg(item, index)
        }
      }
    }, _vm._l((item.image), function(img, idx) {
      return _c('div', {
        key: idx,
        style: ({
          backgroundImage: ("url(" + img)
        })
      }, [_c('p', {
        staticClass: "pageNumShow"
      }, [_vm._v("P" + _vm._s(index + 1))])])
    }), 0), _vm._v(" "), _c('Poptip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.doWhat == 'edit'),
        expression: "doWhat=='edit'"
      }],
      staticClass: "poptip-remove",
      attrs: {
        "confirm": "",
        "title": "您确定要删除此页么？",
        "transfer": true
      },
      on: {
        "on-ok": function($event) {
          return _vm.onRemoveChgPage(index)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-close-circle",
        "size": "16",
        "color": "#ed4014"
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "oidFlex"
  }, [_c('a', {
    staticClass: "upArrow",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.arrowHandle('up')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-arrow-up",
      "size": "20",
      "color": "#555555"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "downArrow",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.arrowHandle('down')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-arrow-down",
      "size": "20",
      "color": "#555555"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmChg
    }
  }, [_vm._v("确定替换")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancelChg
    }
  }, [_vm._v("取消替换")])], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6530f0d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/addBook/PreviewBar.vue
// module id = 705
// module chunks = 1